import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import  './plugins/axios'
import './Content/styles/minify/main.min.css'
import './Content/styles/slick.css'
import VeeValidate, { Validator } from 'vee-validate'
import CpfValidator from './components/validators/cpf.validator'
import CnsValidator from './components/validators/cns.validator'
import Dictionary from './components/validators/dictionary'
import JsonCSV from 'vue-json-csv'

Validator.extend('cpf', CpfValidator)
Validator.extend('cns', CnsValidator)
Vue.component('downloadCsv', JsonCSV)

Vue.use(VeeValidate, {locale: 'pt', dictionary: Dictionary})

Vue.config.productionTip = false

new Vue({
  JsonCSV,
  router,
  store,
  VeeValidate,
  render: h => h(App)
}).$mount('#app')
